console.log("flare rerender loaded");

(function () {

  function initFlare() {
    try {
      if (window.Flare && typeof window.Flare.init === "function") {
        window.Flare.init();
      }
      if (window.flare && typeof window.flare.init === "function") {
        window.flare.init();
      }
    } catch (e) {}
  }

  // Re-init after ANY click that could open cart
  document.addEventListener("click", function () {
    setTimeout(initFlare, 300);
  });

  // Re-init after AJAX cart updates
  document.addEventListener("cart:updated", function () {
    setTimeout(initFlare, 300);
  });

  // Also run once on load
  setTimeout(initFlare, 500);

})();